__turbopack_context__.v({
  "root": "CarouselPillButton-module__YA45Sq__root",
});
